import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { NavigationProject } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import Budgets from "@src/components/modules/projects/budgets-old/Budgets";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    fullWidth
    noGutters
    noBottomMargin
    title={t`Project Budgets`}
    navigation={<NavigationProject id={id} />}
  >
    <Budgets id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/projects/budgets-old")({
  component: RouteComponent,
});
